/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';

import styles from 'src/shared/app/authentication/component/base/AuthenticationBase.style';

import RetrieveUsernameSuccess from './RetrieveUsernameSuccess';
import RetrieveUsernameForm from './RetrieveUsernameForm';
import messages from 'src/shared/app/authentication/l10n/retrieveUsernameL10n';
import { loginSupportRoute } from 'src/shared/app/base/route/setting/routeSettings';
import useRoutes from 'src/shared/app/base/route/hook/useRoutes';
import ZIndexTopBar from 'src/shared/app/base/component/template/component/TopBar';
import TopBar, {
  backButton,
} from 'src/shared/app/nav/component/top-bar/TopBar';

type Props = {
  isUsernameRetrieved: boolean,
};

const useStyles = createUseStyles(styles);

const RetrieveUsernameSectionDumb = ({
  isUsernameRetrieved,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const intl = useIntl();
  const [loginSupportPath] = useRoutes(loginSupportRoute);

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  const elt = isUsernameRetrieved ? (
    <RetrieveUsernameSuccess />
  ) : (
    <RetrieveUsernameForm />
  );

  return (
    <section className={classes.section}>
      <ZIndexTopBar>
        <TopBar
          title={intl.formatMessage(messages.heading)}
          backTo={loginSupportPath}
          variant={!isUsernameRetrieved ? backButton : null}
        />
      </ZIndexTopBar>
      {elt}
    </section>
  );
};

export default compose(React.memo)(RetrieveUsernameSectionDumb);
